export default __webpack_public_path__ + "img/ff0102e3ce0025b2605bfe0185cd363c.svg";